import { RefObject, useEffect } from 'react'

/**
 * Focuses an input element on mount without triggering Safari scroll issues.
 * Uses requestAnimationFrame and preventScroll to avoid viewport jumping.
 */
export const useFocusOnMount = (
  inputRef: RefObject<HTMLInputElement | null>,
  dependency?: unknown,
) => {
  useEffect(() => {
    const node = inputRef.current
    if (!node) return

    const raf = requestAnimationFrame(() => {
      if (document.activeElement === node) return
      const { scrollX, scrollY } = window
      try {
        node.focus({ preventScroll: true })
      } catch {
        node.focus()
        window.scrollTo(scrollX, scrollY)
      }
    })

    return () => cancelAnimationFrame(raf)
  }, [inputRef, dependency])
}
